module.exports = __webpack_public_path__ + "static/media/kpicheck.ba072096.svg";